module.exports = __webpack_public_path__ + "static/love-mobile-d5680b4e8dafe78afbe9f236e08e9cb9.png";